import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "antd/dist/antd.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import * as serviceWorker from "./serviceWorker";


// import i18n (needs to be bundled ;))
import './i18n';

//Using react-app-rewired need this lines
import dotenv from 'dotenv';
dotenv.config();

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
